
const booking = {
    name: 'Nombre',
    description: 'Descripción',
    allowReservations: 'Permitir reservas',
    reservationRequired: 'Reservierung erforderlich',
    moreInfo: '+ info',
    cancelReservation: 'Cancel r.',
    reservation: 'Buchen',
    addCalendar: '+ CAL',
    place: 'Ort',
    meetingPoint: 'Treffpunkt',
    lat: 'Latitud',
    lon: 'Longitud',
    complete: 'Ausgebucht',
    allowReservation: 'Permitir reservar',
    imagesFolder: 'Carpeta de imágenes',
    pleaseStandBy: 'Por favor espere',
    filter: 'Filter',
    info: 'Info',
    typeLimit: {
      days: 'tage',
      minutes: 'minuten',
      hours: 'stunde',
      from: 'von',
      to: 'bis',
      before: 'vor',
      canBeReserved: 'Können Sie buchen',
    },
    acttiv: {
      hotel: 'Hotel',
    },
    activities: {
      title: 'Actividades',
      addActivity: 'Añadir actividad',
      editActivity: 'Editar actividad',
      seats: 'Plazas',
    },
    schedules: {
      title: 'Programaciones',
      addSchedule: 'Añadir programación',
    },
    scheduleForm: {
      title: 'Programa',
      alias: 'Alias',
      startTime: 'Hora inicio',
      interval: 'Intervalo',
      type: 'Tipo',
      byDay: 'Por fechas',
      byWeek: 'Por semanas',
      byMonth: 'Por mes',
      allDay: 'Todo el día',
      duration: 'Duración',
    },
    formFields: {
      owner: 'Comprador',
      pax: 'Asistente',
      title: 'Campos del formulario',
      name: 'Nombre',
      lastName: 'Apellidos',
      email: 'Email',
      fullName: 'Nombre completo',
      phone: 'Teléfono',
      room: 'Habitación',
      locale: 'Idioma',
      age: 'Edad',
      allergens: 'Allergene',
      observations: 'Observaciones',
      add: 'Añadir',
      type: 'Tipo',
    },
    calendar: {
      today: 'Hoy',
      day: 'Día',
      week: 'Semana',
      month: 'Mes',
      fourDays: '4 días',
      available: 'Disponibles',
      reserved: 'Reservadas',
      canceled: 'Canceladas',
      goToReservationList: 'Ir al listado de reservas',
    },
    notifications: {
      title: 'Notificaciones',
      sendOwnerMail: 'Enviar email de reserva al cliente',
    },
    reservations: {
      title: 'Reservas',
      numPax: 'Número de asistentes',
      field: 'Campo',
      addReservation: 'Buchung hinzufügen',
      editReservation: 'Editar reserva',
      clientData: 'Daten der Kunden',
      paxData: 'Datos de participantes',
      addPax: 'Añadir participante',
      pax: 'Participante',
      owner: 'Cliente',
      time: 'Hora',
      activity: 'Actividad',
      cu: 'Creado por',
      lmu: 'Actualizado por',
      withBooks: 'con reservas',
      withCancelBooks: 'con reservas canceladas',
      required: 'Requerido',
      key: 'Identificador interno',
      label: 'Etiqueta',
      exceededCapacity: 'Exceeded capacity',
      limitFieldsTime: 'Límite de reservas por cliente excedido',
      adultsPax: 'Erwachsene',
      childrensPax: 'Kinder',
      babiesPax: 'Säuglinge',
      activityColor: {
        typeColor: 'Tipo',
        weekPrimaryColor: 'Semana primario',
        weekSecondaryColor: 'Semana secundario',
        contentColor: 'Color contenido',
        titleColor: 'Color título',
        timeColor: 'Color hora',
      },
      formFieldsTypes: {
        title: 'Tipo',
        text: 'Texto',
      },
      status: {
        title: 'Estado',
        default: 'Reservado',
        canceled: 'Cancelado',
      },
      messages: {
        fieldRequired: 'Required',
        fieldNotValid: 'Not valid',
        noData: 'There are no reservations for the selected date',
        noEventsForSelectedDate: 'There are no events for the selected date',
        statusCanceledNoEditable: 'Las reservas canceladas no se pueden editar',
        exceededCapacity: 'Aforo excedido',
        limitFieldsTime: 'Límite de reservas por cliente excedido',
        resourceNotAvailable: 'Recurso no disponible',
      },
    },
}
export default booking
